import { PostDeReferralsValidateResponse } from '@iwoca/lapi-client/edge_de';

const DE_REFERRAL_SESSION_KEY = 'de_referral_session';

export type TReferralSession = {
  referral_code: string;
  referral_session_id: number;
  expires_at: string;
};

export function saveReferralSession(
  referralCode: string,
  result: PostDeReferralsValidateResponse,
): void {
  if (!result.valid || !result.referral_session_id || !result.expires_at)
    return;
  const session: TReferralSession = {
    referral_code: referralCode,
    referral_session_id: result.referral_session_id,
    expires_at: result.expires_at,
  };
  localStorage.setItem(DE_REFERRAL_SESSION_KEY, JSON.stringify(session));
}

export function removeReferralSession(): void {
  localStorage.removeItem(DE_REFERRAL_SESSION_KEY);
}

export function getReferralSession(): TReferralSession | null {
  try {
    const raw = localStorage.getItem(DE_REFERRAL_SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw) as TReferralSession;
    const expiry = new Date(session.expires_at);
    if (isNaN(expiry.getTime()) || expiry <= new Date()) {
      localStorage.removeItem(DE_REFERRAL_SESSION_KEY);
      return null;
    }
    return session;
  } catch {
    return null;
  }
}
